/** Primary emerald gradient used for brand surfaces (header, sidebar, logos). */
export const BRAND_GRADIENT = "linear-gradient(135deg, #10b981, #059669)";

/** Single-letter brand mark. */
export const BRAND_INITIAL = "L";

/** Short application name. */
export const APP_SHORT_NAME = "LTS";

/** Full application name. */
export const APP_FULL_NAME = "Pinehood LTS";

/** Theme color (emerald). */
export const BRAND_COLOR = "#10b981";

/** Public static IP of the server where services are exposed. */
export const SERVER_PUBLIC_IP = "78.47.65.185";
